import { UserContext } from "../context/UserContext"
import { useContext } from "react"

/**
 * @returns {context | Object} basically this is a wrapper that consumes the context and checks if the context exists before returning 
 * it within a hook
 */

export const useUserContext = () => {
    const context = useContext(UserContext)

    // TODO: error handling on the FE 
    if (!context) {
        throw new Error("No context found")
    }

    return context
}